<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单与报名</el-breadcrumb-item>
      <el-breadcrumb-item>报名人列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <el-row :gutter="10" class="filter-row">
        <el-col :span="8">
            <el-input 
                placeholder="订单编号" 
                v-model="searchQuery.order_no"
                clearable 
                @clear="handleSearch()" 
                @keyup.enter.native="handleSearch()"
                size="medium">
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
        </el-col>
        <el-col :span="4">
            <el-select
                size="medium"
                placeholder="订单状态"
                @change="handleSearch()"
                v-model="searchQuery.order_status">
                <el-option label="待支付" :value="0"></el-option>
                <el-option label="已支付" :value="1"></el-option>
                <el-option label="已取消" :value="2"></el-option>
                <el-option label="已退款" :value="3"></el-option>
            </el-select>
        </el-col>
        <el-col :span="8">
          <el-select 
            size="medium"
            style="width: 100%"
            placeholder="请选择活动"
            @change="handleSearch()"
            v-model="searchQuery.activity_id" 
            popper-class="activity-select-dropdown">
            <el-option
              v-for="item in activityOptions"
              :key="item.activity_id"
              :label="item.title_cn"
              :value="item.activity_id">
              <div class="activity-option">
                <div class="activity-info">
                  <span>{{ item.title_cn }}</span>
                  <div class="activity-meta">
                    <el-tag size="mini" :type="getStatusType(item.status)">
                      {{ getStatusText(item.status) }}
                    </el-tag>
                    <span class="activity-price">￥{{ item.price }}</span>
                  </div>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="switch-col">
          <el-switch
            v-model="showActive"
            inactive-text="仅有效"
            active-text="所有"
            @change="fetchActivities">
          </el-switch>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-input 
            placeholder="报名人姓名" 
            v-model="searchQuery.name" 
            clearable  
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input 
            placeholder="报名人手机号" 
            v-model="searchQuery.phone" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input 
            placeholder="报名人身份证号" 
            v-model="searchQuery.id_card_number" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input 
            placeholder="紧急联系人姓名" 
            v-model="searchQuery.emergency_contact_name" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input 
            placeholder="紧急联系人电话" 
            v-model="searchQuery.emergency_contact_phone" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
          <el-button type="primary" @click="handleSearch()" size="medium" plain>搜索</el-button>
        </el-col>
      </el-row>

      <!-- 报名列表 -->
      <el-table :data="participantList" style="width: 100%" border>
        <el-table-column type="index" prop="id" align="center"></el-table-column>
        <el-table-column label="姓名" prop="name" align="center"></el-table-column>
        <el-table-column label="身份证号" prop="id_card_number" align="center"></el-table-column>
        <el-table-column label="手机号" prop="phone" align="center"></el-table-column>
        <el-table-column label="紧急联系人" prop="emergency_contact_name" align="center"></el-table-column>
        <el-table-column label="信息完善度" align="center">
          <template slot-scope="scope">
            <el-progress
              class="desc-progress-bar"
              :percentage="getProgress(scope.row)"
              :color="customColors"
              :show-text="false"
              :stroke-width="4"
            />
          </template>
        </el-table-column>
        <el-table-column label="报名状态"  width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.signup_status === 0 ? 'info' : 'success'" effect="plain">
              {{ scope.row.signup_status === 0 ? '未报名' : '已报名' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单编号"  width="160" prop="order_no" align="center"></el-table-column>
        <el-table-column label="查看详情" width="80" align="center" class="clickable-order-no">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-view" @click="viewDetails(scope.row.order_no)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import filterMixin from '@/utils/filter.js'

export default {
  name: 'Enrolls',
  mixins: [filterMixin],
  data() {
    return {
      sessionKey: 'EnrollsSearch',
      filterFetchMethod: 'fetchParticipants',
      total: 0,
      pageNum: 1,
      pageSize: 10,
      participantList: [],
      searchQuery: {
        name: '',
        phone: '',
        order_no: '',
        activity_id: null,
        order_status: null,
        emergency_contact_name: '',
        emergency_contact_phone: '',
        id_card_number: ''
      },
      activityOptions: [],
      activityStatusMap: {
        1: '未开始',
        2: '进行中',
        3: '已结束'
      },
      showActive: false,
      activityStatusTagTypes: {
        1: 'primary',    // 未开始
        2: 'success', // 进行中
        3: 'info'  // 已结束
      },
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#1989fa', percentage: 60},
        {color: '#13c2c2', percentage: 90},
        {color: '#5cb87a', percentage: 100}
      ],
      // 新增用户信息相关字段
      currentUser: null,
      isTeacherRole: false
    }
  },
  created() {
    this.getCurrentUser()
  },
  methods: {
    // 获取当前用户信息
    getCurrentUser() {
      this.$http({
        method: 'get',
        url: 'users/me'
      }).then(res => {
        this.currentUser = res.data
        this.isTeacherRole = res.data.role === 6
        this.fetchActivities()
        this.fetchParticipants()
      }).catch(err => {
        this.fetchActivities()
        this.fetchParticipants()
        this.$message.error(err.response?.data?.message || '获取用户信息失败')
      })
    },

    fetchParticipants() {
      this.$http({
        method: 'get',
        url: '/participants',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.participantList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取报名列表失败')
      })
    },

    fetchActivities() {
      // 如果是带队老师，只获取他们负责的活动
      const params = {
        is_deleted: this.showActive ? null : 0
      }
      
      // 如果是带队老师且有分配的活动，则只获取这些活动
      if (this.isTeacherRole && this.currentUser?.activity_ids && this.currentUser.activity_ids.length > 0) {
        params.activity_ids = this.currentUser.activity_ids.join(',')
      }
      
      this.$http({
        method: 'get',
        url: '/activities/search',
        params: params
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.activityOptions = res.data
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取活动列表失败')
      })
    },

    viewDetails(order_no) {
      this.$router.push(`/admin/enroll/details/${order_no}`)
    },

    getStatusText(status) {
      return this.activityStatusMap[status] || '未知'
    },

    getStatusType(status) {
      return this.activityStatusTagTypes[status] || 'info'
    },

    handleSearch() {
      this.pageNum = 1
      this.fetchParticipants()
    },

    resetSearch() {
      this.searchQuery = { order_no: '', activity_id: null, name: '', phone: '', emergency_contact_name: '', emergency_contact_phone: '', order_status: null, id_card_number: '' }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchActivities()
      this.fetchParticipants()
    },

    formatDateTime(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchParticipants()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchParticipants()
    },

    getProgress(participant) {
      if (!participant) return 0;
      const fields = [
        'age', 'blood_type', 'dietary_taboo', 'drug_allergy', 'favorite_color', 'favorite_subject',
        'gender', 'grade', 'height', 'hobbies', 'household', 'id_card_back', 'id_card_front',
        'id_card_number', 'id_card_type', 'learning_desc', 'name', 'personality_traits', 'phone',
        'school', 'sleep_status', 'weak_subject', 'weight'
      ];
      let filled = 0;
      fields.forEach(key => {
        const val = participant[key];
        if (val !== null && val !== undefined && val !== '') filled++;
      });
      return Math.round((filled / fields.length) * 100);
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}

.el-table {
  margin-top: 15px;
}

.el-pagination {
  margin-top: 15px;
}

.activity-option {
  padding: 6px;
}

.activity-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.activity-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.activity-price {
  color: #f56c6c;
  font-size: 12px;
  font-weight: 500;
  min-width: 40px;
  text-align: right;
}

.activity-select-dropdown .el-select-dropdown__item {
  padding: 0 8px !important;
  height: auto !important;
}

.filter-row {
  margin-bottom: 10px;
}

.switch-col {
  display: flex;
  align-items: center;
  height: 35px;
}

.clickable-order-no {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}

.clickable-order-no:hover {
  color: #66b1ff;
}

.desc-progress-bar {
  margin: 0 auto;
  width: 60%;
  vertical-align: middle;
}
</style>
